import {logger} from "../utils/Log";
import {AbstractGateway} from "./AbstractGateway";
import {JqueryApp} from "../JqueryApp";
import {PaymentChargeResponse} from "../structs/Payment";

export class GatewayUs extends AbstractGateway { // PayStack
    constructor(app: JqueryApp) {
        super(app);
    }

    public async connectForm() {
        const config = this.app.getConfig();
        if (!config.gateway || !config.gateway.key) {
            window.alert(this.app.getTr().get("gatewayConfigError"));
            return;
        }
        const {loadStripe} = await import('@stripe/stripe-js'); // code splitting
        const stripe = await loadStripe(config.gateway.key);
        //stripe.confirmCardPayment(paymentIntent.client_secret);

        const elements = stripe.elements();

        // Create individual Elements
        const style = {
            base: {
                color: "#32325d",
                fontFamily: 'Arial, sans-serif',
                fontSmoothing: "antialiased",
                fontSize: "16px",
                lineHeight: "40px",
                //border: "1px solid #e5e6e7", // doesn't work, needs JS
                "::placeholder": {
                    color: "#aab7c4"
                }
            },
            invalid: {
                color: "#cf0d17",
                iconColor: "#fa755a"
            }
        };

        const cardNumber = elements.create('cardNumber', { style });
        const cardExpiry = elements.create('cardExpiry', { style });
        const cardCvc = elements.create('cardCvc', { style });

        const nrEl = document.getElementById("cardNumber");
        nrEl.style.minWidth = "275px";
        this.styleInput(nrEl);
        const expiryEl = document.getElementById("cardExpiry");
        expiryEl.style.minWidth = "120px";
        this.styleInput(expiryEl);
        const cvvEl = document.getElementById("cvv");
        cvvEl.style.minWidth = "100px";
        this.styleInput(cvvEl);

        // Mount the elements to the DOM
        cardNumber.mount('#cardNumber');
        cardExpiry.mount('#cardExpiry');
        //const expMonthSelect = document.getElementById('credit_expiry_month') as HTMLOptionElement; // TODO JS API for card expiry removed?
        //const expYearSelect = document.getElementById('credit_expiry_year') as HTMLOptionElement;
        cardCvc.mount('#cvv');

        // Handle form submission
        const form = document.getElementById('payauth-form');
        form.addEventListener('submit', async (event) => {
            event.preventDefault();

            // Create a token
            //const expMonth = expMonthSelect.value;
            //const expYear = expYearSelect.value;
            const { token, error } = await stripe.createToken(cardNumber, {
                //exp_month: expMonth,
                //exp_year: expYear
            });

            if (error && error.message) {
                document.getElementById('card-errors').textContent = error.message;
                return;
            }
            //console.log('Token created:', token.id);

            // Send the token to your server
            this.sendPaymentToken(token.id);
        });
    }

    // ################################################################
    // ###################### PRIVATE FUNCTIONS #######################

    protected sendPaymentToken(token: string) {
        const config = this.app.getConfig();
        const payment = config.payment;
        const fullToken = payment.token + "-" + payment.merchantId;
        const url = config.apiBase + config.submitCardToken + "/" + fullToken;
        const data = {
            token: token,
        };
        this.webHelpers.postApi(url, data, (data: PaymentChargeResponse) => {
            if (data && data.errorUser)
                document.getElementById('card-errors').textContent = data.errorUser;
            if (data.payment && data.payment.status === "DECLINED") {
                window.location.reload(); // show declined and possibly other payment options
                return;
            }
            if (!data || data.error) {
                console.error("Error submitting card token", data);
                return;
            }
            //console.log("RES", data)

            if (data.payment && data.payment.status === "PAID") {
                window.location.assign(config.pathPayDone + "/" + fullToken + window.document.location.search);
            }
        }).fail((err) => {
            console.error("Error HTTP submitting card token", err);
        });
    }

    protected styleInput(el: HTMLElement) {
        el.style.border = "1px solid #e5e6e7"; // Adds a border manually
        //el.style.padding = "10px"; // Adds padding
        //el.style.borderRadius = "5px"; // Rounds corners
        el.style.paddingLeft = "10px"; // for placeholders
    }
}
